/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface ContactDoublonLieuFormationDto
 */
export interface ContactDoublonLieuFormationDto {
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonLieuFormationDto
     */
    idcontactLieu?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonLieuFormationDto
     */
    idcontact?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonLieuFormationDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonLieuFormationDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonLieuFormationDto
     */
    enseigne?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactDoublonLieuFormationDto
     */
    principal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonLieuFormationDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContactDoublonLieuFormationDto
     */
    sortieEntreprise?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonLieuFormationDto
     */
    remarqueLieu?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactDoublonLieuFormationDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactDoublonLieuFormationDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof ContactDoublonLieuFormationDto
     */
    email?: EmailDto;
}

/**
 * Check if a given object implements the ContactDoublonLieuFormationDto interface.
 */
export function instanceOfContactDoublonLieuFormationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactDoublonLieuFormationDtoFromJSON(json: any): ContactDoublonLieuFormationDto {
    return ContactDoublonLieuFormationDtoFromJSONTyped(json, false);
}

export function ContactDoublonLieuFormationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDoublonLieuFormationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontactLieu': !exists(json, 'idcontactLieu') ? undefined : json['idcontactLieu'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'enseigne': !exists(json, 'enseigne') ? undefined : json['enseigne'],
        'principal': !exists(json, 'principal') ? undefined : json['principal'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'sortieEntreprise': !exists(json, 'sortieEntreprise') ? undefined : (json['sortieEntreprise'] === null ? null : new Date(json['sortieEntreprise'])),
        'remarqueLieu': !exists(json, 'remarqueLieu') ? undefined : json['remarqueLieu'],
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
    };
}

export function ContactDoublonLieuFormationDtoToJSON(value?: ContactDoublonLieuFormationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontactLieu': value.idcontactLieu,
        'idcontact': value.idcontact,
        'idlieuFormation': value.idlieuFormation,
        'nom': value.nom,
        'enseigne': value.enseigne,
        'principal': value.principal,
        'fonction': value.fonction,
        'sortieEntreprise': value.sortieEntreprise === undefined ? undefined : (value.sortieEntreprise === null ? null : value.sortieEntreprise.toISOString()),
        'remarqueLieu': value.remarqueLieu,
        'telephone': TelephoneDtoToJSON(value.telephone),
        'gsm': TelephoneDtoToJSON(value.gsm),
        'email': EmailDtoToJSON(value.email),
    };
}

